<!-- <div class="footer">
    <div class="footer_box">
      <div class="footer_box_top">
        <div class="footer_box_top_left">
            <img class="footer_box_top_left_logo" [src]="baseurl + footerdata.footer_logo" />
            <div class="footer_box_top_left_info text_style_1">
            <p>{{ footerdata.description }}</p>
          </div>
        </div>
        <div class="footer_box_top_center">
          <p class="text_style_2">Quick Links</p>
          <ul class="footer_box_top_center_list text_style_1">
            <li class="footer_box_top_center_list_item cursor-pointer" routerLink="/home">Home</li>
            <li class="footer_box_top_center_list_item cursor-pointer" routerLink="/about_us">About Us</li>
            <li class="footer_box_top_center_list_item cursor-pointer" routerLink="/client">Clients</li>
            <li class="footer_box_top_center_list_item cursor-pointer" routerLink="/career_at">Career</li>
            <li class="footer_box_top_center_list_item cursor-pointer" routerLink="/contact_us">Contact Us</li>
          </ul>
        </div>
        <div class="footer_box_top_right">
          <p class="text_style_2">Contact Us</p>
          <div class="footer_box_top_right_items">
            <div>
              <img src="../../../assets/icons/pincode_icon.png" />
            </div>
            <div>
              <p class="text_style_1">{{ footerdata.address }}</p>
            </div>
            <div>
              <img src="../../../assets/icons/phone_icon.png" />
            </div>
            <div>
              <p class="text_style_1">{{ footerdata.mobile_number }}</p>
            </div>
            <div>
              <img src="../../../assets/icons/email_icon.png" />
            </div>
            <div>
              <p class="text_style_1">{{ footerdata.email }}</p>
            </div>
          </div>
        </div>
      </div>
  
      <div class="footer_box_bottom">
        <div class="footer_box_bottom_text text_style_3">
          <p class="footer_box_bottom_text_item1">{{ footerdata.copyright }}</p>
          <p class="footer_box_bottom_text_item3 text-end">
            <span>Follow us on</span>
            <a class="footer_box_bottom_text_item3_icon cursor-pointer" [href]="footerdata.facebook_URL" target="_blank">
              <img src="../../../assets/icons/facebook.png" />
            </a>
            <a class="footer_box_bottom_text_item3_icon cursor-pointer" [href]="footerdata.linkdin_URL" target="_blank">
              <img src="../../../assets/icons/linkdin_black.png" />
            </a>
            <a class="footer_box_bottom_text_item3_icon cursor-pointer" [href]="footerdata.youtube_URL" target="_blank">
              <img src="../../../assets/icons/youtube.png" />
            </a>
            <a class="footer_box_bottom_text_item3_icon cursor-pointer" [href]="footerdata.instagram_URL" target="_blank">
              <img src="../../../assets/icons/instagram.png" />
            </a>
          </p>
        </div>
      </div>
      
    </div>
  </div> -->
<div class="footer">
  <div class="footer_box">
    <div class="footer_box_top">
      <div class="footer_box_top_left">
        <img class="footer_box_top_left_logo"
          src="https://www.chemrobotics.com/agropat/uploads/thumbnail/header_logo_1726637785151.png" alt="Logo" />
        <!-- Original dynamic logic was here -->
        <div class="footer_box_top_left_info text_style_1">
          <p
            [innerHtml]="footerdata?.description || 'Providing comprehensive information on Agrochemicals, Pharma and Specialty Chemicals.'">
          </p>
        </div>
      </div>
      <div class="footer_box_top_center">
        <p class="text_style_2">Quick Links</p>
        <ul class="footer_box_top_center_list text_style_1">
          <li class="footer_box_top_center_list_item cursor-pointer" routerLink="/home" (click)="scrollToTop()">
            Home
          </li>
          <li class="footer_box_top_center_list_item cursor-pointer" routerLink="/about-us" (click)="scrollToTop()">
            About Us
          </li>
          <li class="footer_box_top_center_list_item cursor-pointer" routerLink="/clients" (click)="scrollToTop()">
            Clients
          </li>
          <li class="footer_box_top_center_list_item cursor-pointer" routerLink="/career" (click)="scrollToTop()">
            Career
          </li>
          <li class="footer_box_top_center_list_item cursor-pointer" routerLink="/contact" (click)="scrollToTop()">
            Contact Us
          </li>
          <li class="footer_box_top_center_list_item cursor-pointer" routerLink="/ethics" (click)="scrollToTop()">
            Code of Ethics
          </li>
        </ul>
      </div>
      <div class="footer_box_top_center1">
        <p class="text_style_2">Quick Links</p>
        <div class="footer_box_top_center1_list text_style_1">
          <div class="footer_box_top_center1_list_box" routerLink="/home" (click)="scrollToTop()">
            <div class="footer_box_top_center1_list_box_item cursor-pointer">
              <div>&ndash;</div>
              <div>Home</div>
            </div>
          </div>
          <div class="footer_box_top_center1_list_box" routerLink="/about-us" (click)="scrollToTop()">
            <div class="footer_box_top_center1_list_box_item cursor-pointer">
              <div>&ndash;</div>
              <div>About Us</div>
            </div>
          </div>

          <div class="footer_box_top_center1_list_box" routerLink="/clients" (click)="scrollToTop()">
            <div class="footer_box_top_center1_list_box_item cursor-pointer">
              <div>&ndash;</div>
              <div>Clients</div>
            </div>
          </div>
          <div class="footer_box_top_center1_list_box" routerLink="/career" (click)="scrollToTop()">
            <div class="footer_box_top_center1_list_box_item cursor-pointer">
              <div>&ndash;</div>
              <div>Career</div>
            </div>
          </div>
          <div class="footer_box_top_center1_list_box cursor-pointer" routerLink="/contact" (click)="scrollToTop()">
            <div class="footer_box_top_center1_list_box_item cursor-pointer">
              <div>&ndash;</div>
              <a>Contact Us</a>
            </div>
          </div>
          <div class="footer_box_top_center1_list_box cursor-pointer" routerLink="/ethics" (click)="scrollToTop()">
            <div class="footer_box_top_center1_list_box_item cursor-pointer">
              <div>&ndash;</div>
              <a>Code of Ethics</a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_box_top_right">
        <p class="text_style_2">Contact Us</p>
        <div class="footer_box_top_right_items">
          <div>
            <img src="../../../assets/icons/pincode_icon.png" />
          </div>
          <div>
            <p class="text_style_1">{{ footerdata?.address || 'Indore, MP, India' }}</p>
          </div>
          <div>
            <img src="../../../assets/icons/phone_icon.png" />
          </div>
          <div>
            <p class="text_style_1">{{ footerdata?.mobile_number || '+91-626 611 7944' }}</p>
          </div>
          <div>
            <img src="../../../assets/icons/email_icon.png" />
          </div>
          <div>
            <p class="text_style_1">{{ footerdata?.email || 'support@chemrobotics.com' }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="dis-flex-2">
      <a
        href="https://chat.whatsapp.com/HQ4vy7F2g1AKuGXOqk7CkQ"
        target="_blank"
        class="text_decoration_none cursor-pointer"
      >
        <div style="display: flex; align-items: center; margin-top: 10px">
          <img
            src="../../../assets/icons/whatsapp_icon.png"
            alt="WhatsApp Icon"
            width="50px"
            height="50px"
          />
          <span style="margin-left: 5px" class="text_style_1"
            >Subscribe for Latest News & Update</span
          >
        </div>
      </a>
    </div> -->
    <div class="row">
      <div class="col md-4">
        <div>
          <a href="https://wa.me/916266117944" target="_blank" class="text_decoration_none cursor-pointer">
            <div style="display: flex; align-items: center; margin-top: 10px">
              <img src="../../../assets/icons/whatsapp_icon.png" alt="WhatsApp Icon" width="50px" height="50px" />
              <span style="margin-left: 5px" class="text_style_1">Chat With Us</span>
            </div>
          </a>
        </div>
      </div>
      <div class="col md-4">
        <div class="dis-flex-2">
          <a href="https://chat.whatsapp.com/HQ4vy7F2g1AKuGXOqk7CkQ" target="_blank"
            class="text_decoration_none cursor-pointer">
            <div style="display: flex; align-items: center; margin-top: 10px">
              <img src="../../../assets/icons/whatsapp_icon.png" alt="WhatsApp Icon" width="50px" height="50px" />
              <span style="margin-left: 5px" class="text_style_1">Subscribe for Latest News & Update</span>
            </div>
          </a>
        </div>
      </div>
      <div class="col md-4">
        <div style="display: flex; justify-content: end">
          <div style="display: flex; align-items: right; margin-top: 25px">
            <span style="margin-left: 5px" class="text_style_1">View page in full screen -
              <a href="https://www.chemrobotics.com/registration" class="text_blue_17 cursor-pointer" target="_blank"
                style="text-decoration: none">Sign Up</a>
              &nbsp;|&nbsp;
              <a href="https://www.chemrobotics.com/demo_request" class="text_blue_17 cursor-pointer" target="_blank"
                style="text-decoration: none">Demo Request</a></span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer_box_bottom">
      <div class="footer_box_bottom_text text_style_3">
        <p class="footer_box_bottom_text_item1">{{ footerdata?.copyright || '© 2026 ChemRobotics. All Rights Reserved.'
          }}</p>
        <p class="footer_box_bottom_text_item2 text-center">
          <span>Terms of Use</span>&nbsp;and&nbsp;
          <span>Privacy Policy</span>
        </p>
        <p class="footer_box_bottom_text_item3 text-end">
          <span>Follow us on</span>
          <a class="footer_box_bottom_text_item3_icon cursor-pointer" [href]="footerdata?.facebook_URL || '#'"
            target="_blank">
            <img src="../../../assets/icons/facebook.png" />
          </a>
          <a class="footer_box_bottom_text_item3_icon cursor-pointer" [href]="footerdata?.linkdin_URL || '#'"
            target="_blank">
            <img src="../../../assets/icons/linkdin_black.png" />
          </a>
          <a class="footer_box_bottom_text_item3_icon cursor-pointer" [href]="footerdata?.youtube_URL || '#'"
            target="_blank">
            <img src="../../../assets/icons/youtube.png" />
          </a>
          <a class="footer_box_bottom_text_item3_icon cursor-pointer" [href]="footerdata?.instagram_URL || '#'"
            target="_blank">
            <img src="../../../assets/icons/instagram.png" />
          </a>
        </p>
      </div>
      <div class="text_align-right">
        <span class="text-red-1">For better experience, please use ‘Google Chrome' browser</span>
      </div>
    </div>
  </div>
</div>